// Monarch configuration constants
export const MONARCH_SOURCE_ID = "bdac7c16-924e-4180-bb35-5b2dfff6d308";
export const MONARCH_ENDPOINT = "https://www.edx.org/beam";
export const MONARCH_TOKEN = "b43382aa-9f76-406c-a628-bf96086f1c28";
